import { from, of } from 'rxjs';
import { publishReplay, refCount, switchMap } from 'rxjs/operators';
import { getAuthenticationConfiguration } from './getAuthenticationConfiguration';

export const authenticationConfiguration$ = of(1).pipe(
  switchMap(v => from(getAuthenticationConfiguration())),
  publishReplay(1),
  refCount()
);
